import React from 'react'

const WrongRoute = () => {
    return (
      <div className="app-locked">
        <h1>Wrong Route</h1>
        <p>If you are sure that you have the right reservation, use your given url in your Email or call the support team.</p>
      </div>
    )
}

export default WrongRoute